import {updateUrlOnDateSwitchChange, updateUrlParams} from "../../../utils";
import {useSearchParams} from "react-router";
import {CustomerFilterAutoComplete, FieldDateSwitch2, FieldDateSwitchValue} from "../../ui";
import {useEffect, useState} from "react";
import {pageQueryStore, stsCustomerStore} from "../../../store";
import {FieldMultiSelect} from "@kroschke/react-ui";
import {StorageTransferStatusDto} from "../../../api/sts";
import {convertStsStatus} from "../../../api";

const storageTransferStatusDropDownOptions = Object.keys(StorageTransferStatusDto).map(e => ({
    value: e,
    label: convertStsStatus(e as StorageTransferStatusDto)
}))

function StsFilterBar() {
    const [searchParams, setSearchParams] = useSearchParams()
    const status = (searchParams.getAll('status') || [])

    const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
    const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined

    const queryS = searchParams.get('q') || undefined
    const customerIdS = searchParams.get('customerId') || undefined

    const [from, setFrom] = useState<FieldDateSwitchValue | undefined>(fromS ? {
        absolute: searchParams.get('fromAbsolute') || undefined,
        relative: searchParams.get('fromRelative') || undefined,
    } : undefined)
    const [to, setTo] = useState<FieldDateSwitchValue | undefined>(toS ? {
        absolute: searchParams.get('toAbsolute') || undefined,
        relative: searchParams.get('toRelative') || undefined,
    } : undefined)
    const [stsStatus, setStsStatus] = useState(status)

    useEffect(() => {
        const status = (searchParams.getAll('status') || [])

        const toS = searchParams.get('toAbsolute') || searchParams.get('toRelative') || undefined
        const fromS = searchParams.get('fromAbsolute') || searchParams.get('fromRelative') || undefined

        setFrom(fromS ? {
            absolute: searchParams.get('fromAbsolute') || undefined,
            relative: searchParams.get('fromRelative') || undefined,
        } : undefined)
        setTo(toS ? {
            absolute: searchParams.get('toAbsolute') || undefined,
            relative: searchParams.get('toRelative') || undefined,
        } : undefined)

        setStsStatus(status)
    }, [
        searchParams,
        setFrom,
        setTo,
        setStsStatus
    ])

    const hasFilter = Boolean(fromS)
        || Boolean(toS)
        || Boolean(stsStatus.length)
        || Boolean(queryS)
        || Boolean(customerIdS)

    return <div style={{
        display: 'flex',
        zoom: '85%',
        alignItems: 'flex-start',
        zIndex: 1
    }}>
        <div style={{
            minWidth: '2em',
            maxWidth: '12em',
            marginRight: '1em'
        }}>
            <CustomerFilterAutoComplete
                param={'customerId'}
                items={stsCustomerStore.items}
                search={async (q) => await stsCustomerStore.search(q)}
            />
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Von"}
                value={from}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'from', searchParams, setSearchParams)
                    setFrom(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '2em',
            maxWidth: '7.5em',
            marginRight: '1em'
        }}>
            <FieldDateSwitch2
                label={"Bis"}
                value={to}
                onChange={v => {
                    updateUrlOnDateSwitchChange(v, 'to', searchParams, setSearchParams)
                    setTo(v)
                }}
            />
        </div>
        <div style={{
            minWidth: '15em',
            maxWidth: '20em',
            marginRight: '1em'
        }}>
            <FieldMultiSelect
                label={"Status"}
                options={storageTransferStatusDropDownOptions}
                value={stsStatus}
                onChange={value => {
                    updateUrlParams({val: [{param: 'status', value}], setSearchParams, searchParams})
                    setStsStatus(value)
                }}
            />
        </div>
        {<div style={{
            minWidth: '10em',
            maxWidth: '20em',
        }}>
            <button
                className={'button is-primary is-rounded'}
                disabled={!hasFilter}
                onClick={() => {
                    setFrom(undefined)
                    setTo(undefined)
                    Array.from(searchParams.keys()).forEach(key => {
                        searchParams.delete(key)
                    })
                    setSearchParams(searchParams)
                    pageQueryStore.clear('sts')
                }}
                style={{
                    marginTop: '0.3em'
                }}
            >
                <span className={`icon is-small`}>
                    <span className="material-symbols-outlined">filter_list_off</span>
                </span>
                <span>Zurücksetzen</span>
            </button>
        </div>}
    </div>
}
export {
    StsFilterBar
}
